import React from 'react';
import classnames from 'classnames';
import { Tab, TabProps } from './tab';
import { useTheme } from '../theme';

type TabType = {
  key: string;
  label: React.ReactNode;
} & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'>;

export type TabBarProps = {
  size?: TabProps['size'];
  shape?: TabProps['shape'];
  tabs: Array<TabType>;
  selectedKey?: string;
  onChange?: (key: string, index: number) => void;
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'>;

export const TabBar = ({
  size = 'medium',
  shape = 'button',
  className,
  tabs,
  selectedKey,
  onChange,
  ...tabBarProps
}: TabBarProps) => {
  const classNames = classnames(className, 'airtame-tab-bar', `airtame-tab-bar--${shape}`);
  const theme = useTheme();

  const onTabClick = (key: string, index: number) => () => {
    if (key !== selectedKey) {
      onChange?.(key, index);
    }
  };

  return (
    <div className={classNames} data-theme={theme} {...tabBarProps}>
      {tabs.map(({ key, label, disabled, ...tabProps }, index) => (
        <Tab
          key={key}
          selected={!disabled && key === selectedKey}
          onClick={onTabClick(key, index)}
          size={size}
          shape={shape}
          disabled={disabled}
          {...tabProps}
        >
          {label}
        </Tab>
      ))}
    </div>
  );
};
